import * as React from "react"
import { useEffect } from "react"

import { BIChart } from "./@components"
import { BIChartData, BIIs3DTable, BIIsLoadingChart, BIShowByPrice, BIShowChartLegend } from './@signals'
import { validateFormat } from "@utils"


export default function BIChartContent() {

	useEffect(() => {
		BIIsLoadingChart.value = true
		setTimeout(() => {
			BIIsLoadingChart.value = false
		}, 100)
	}, [BIShowChartLegend.value])

	if (!BIChartData.value.chartData || BIIs3DTable.value) return null

	return <BIChart
		xTitle="Days of rental"
		isDateAxis={BIChartData.value.xlist?.every(d => validateFormat("yyyyMMdd", d))}
		titleChart="Chart"
		dataChart={BIChartData.value.chartData[BIShowByPrice.value]}
		seriesToApply={BIChartData.value.keySeries.map(element => ({ ...element, disable: element?.is_previous_period_color }))}
	/>
}